import {createStore} from "@stencil/store";
import {NotificationHandler} from "@trumpf/notifies.notification-handler";
import type {INotification, STAGE} from "@trumpf/notifies.notification-handler";

export const store = createStore<{
	notifications: INotification[];
	counter: number;
	account: string;
	token: string | null;
	error: object | null;
	loading: boolean;
}>({
	notifications: [],
	counter: 0,
	account: "",
	token: null,
	error: null,
	loading: false,
});

const notificationHandler = new NotificationHandler();

const onNotificationReceived = (notification: INotification, totalCount: number) => {
	store.set("loading", false);
	store.state.error = null;
	store.state.counter = totalCount;
	if (store.state.notifications.findIndex((n) => n.id === notification.id) === -1) {
		store.state.notifications = [...store.state.notifications, notification];
		store.state.notifications.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
	}
};

const onNoNewNotification = () => {
	store.set("loading", false);
};

const onNotOk = (response) => {
	store.set("loading", false);
	if (response.status === 401) {
		store.state.error = {
			status: response.status,
			message: response.statusText,
		};
	}
};

export function loadMoreNotifications() {
	notificationHandler.loadMoreNotifications();
}

export function subscribe(token: string, locale: string, version, stage: STAGE): () => void {
	store.set("loading", true);
	const unsubscribeNotificationsCallback = notificationHandler.subscribe({
		onNotificationReceived,
		onNotOk,
		onNoNewNotification,
		token,
		version,
		locale,
		stage,
	});

	return unsubscribeNotificationsCallback;
}
